// extracted by mini-css-extract-plugin
export var audioPlayer = "_oi-0";